import { UPDATE_CASE_FILE_API_URL, UPDATE_RATING_FILE_API_URL } from '../../const/const';
import axios, { AxiosError } from 'axios';

export const updateFileRating = async (
    fileUID: string,
    rating: number,
    userLogin: string,
    SmartDVRToken: string,
) => {
    try {
        const response = await axios.post(
            UPDATE_RATING_FILE_API_URL,
            { UID: fileUID, rating },
            {
                headers: {
                    SmartDVRLogin: userLogin,
                    SmartDVRToken: SmartDVRToken,
                },
            },
        );
        return response;
    } catch (error) {
        const err = error as AxiosError;
        console.error('Error fetching filtered files:', err.response?.status, err.response?.data);
        throw error;
    }
};

export const updateFileCase = async (
    fileUID: string,
    caseNumber: number,
    caseDescription: string,
    userLogin: string,
    SmartDVRToken: string,
) => {
    try {
        const response = await axios.post(
            UPDATE_CASE_FILE_API_URL,
            { UID: fileUID, caseNumber, caseDescription },
            {
                headers: {
                    SmartDVRLogin: userLogin,
                    SmartDVRToken: SmartDVRToken,
                },
            },
        );
        return response;
    } catch (error) {
        const err = error as AxiosError;
        console.error('Error fetching filtered files:', err.response?.status, err.response?.data);
        throw error;
    }
};
